










































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import Typography from '@/components/common/elements/Typography.vue';
import Button from '@/components/common/elements/Button.vue';
import { Items } from '@/services/hexabase/types';

/** APIレスポンスステータス: 成功 */
const API_RESPONSE_STATUS_SUCCESS = 'apiSuccess';
/** APIレスポンスステータス: 失敗（デフォルト） */
const API_RESPONSE_STATUS_FAILURE_DEFAULT = 'apiFailure';
/** APIレスポンスステータス: 失敗（競合によるエラー） */
const API_RESPONSE_STATUS_FAILURE_CONFLICT = 'apiFailureConflict';

/** APIレスポンスメッセージ */
const ApiResponseMessages = [
  { status: API_RESPONSE_STATUS_SUCCESS, message: '処理が完了しました' },
  { status: API_RESPONSE_STATUS_FAILURE_DEFAULT, message: 'エラーが発生しました' },
  { status: API_RESPONSE_STATUS_FAILURE_CONFLICT, message: '別のユーザーがデータを更新しました。\n再読み込みしてから再度実行してください。' },
];

@Component({
  components: { SingleText, Typography, Button },
})
export default class BulkStatusActionDialog extends Vue {
  /** ダイアログ開閉状態 */
  @Prop({ default: false })
  private dialog?: boolean;
  /** ダイアログ内表示タイトル（リクエスト確認/レスポンス共通） */
  @Prop({ default: '' })
  private title!: string;
  /** ダイアログ内表示テキスト（リクエスト確認） */
  @Prop({ default: '' })
  private bodyText!: string;
  /** ダイアログのエリア外を押下した際にダイアログ自身を閉じるか（リクエスト確認/レスポンス共通） */
  @Prop({ default: true })
  private isPersistent?: boolean;
  /** ダイアログ内ボタンをテキストに変更するか（リクエスト確認/レスポンス共通） */
  @Prop({ default: false })
  private isTextActionButtom?: boolean;
  /** ダイアログ内NGボタン文字（リクエスト確認/レスポンス共通） */
  @Prop({ default: 'キャンセル' })
  private buttomTextNG?: string;
  /** ダイアログ内OKボタン文字（レスポンス） */
  @Prop({ default: 'OK' })
  private buttomTextOK?: string;
  /** ダイアログ内NGボタン文字色（リクエスト確認/レスポンス共通） */
  @Prop({ default: 'light' })
  private buttomColorNG?: string;
  /** ダイアログ内OKボタン文字色（レスポンス） */
  @Prop({ default: 'primary' })
  private buttomColorOK?: string;
  // 一覧で選択されたアイテムデータ TODO: 未使用？
  @Prop({ default: () => ([]) })
  private itemData?: Array<Items>;
  // ダイアログ内テーブルに表示するためのカラム TODO: 未使用？
  @Prop({ default: () => ([]) })
  private colums?: Array<{[k: string]: string}>;
  // ダイアログ内に表示するステータスアクション TODO: 未使用？
  @Prop({ default: () => ([]) })
  private actions?: Array<{[k: string]: string}>;
  /**
   * APIリクエストを実行した後のAPIレスポンスオブジェクト
   * TODO: オブジェクトの型をきちんと定義しないと、どんなパラメータを入れればいいのかわからなくなる
   */
  @Prop({ default: () => ({}) })
  private apiResponse?: {[k: string]: any};
  // APIリクエスト成功時に表示する文言
  @Prop({ default: '' })
  private apiSuccessMessage?: string;

  /** APIに問い合わせ中に表示する「loading」フラグ */
  private isLoading = false;
  /** ダイアログ内表示切り分けプロパティ */
  private status = '';
  /** ダイアログ内表示テキスト（レスポンス） */
  private responseMessage = '';

  /**
   * APIの返り値を受け取り、完了・エラーメッセージを表示する
   */
  @Watch('apiResponse')
  private apiResult(): void {
    this.isLoading = false;
    if (this.apiResponse && Object.keys(this.apiResponse!).length > 0) {
      // 前回表示したメッセージが残ったままのことがあるのでリセット
      this.responseMessage = '';
      const isError: boolean = this.apiResponse.error;
      if (isError) {
        // エラーがある場合
        const errStatus = this.apiResponse.errorStatus;
        switch (errStatus) {
          case 409:
            // 409 Conflict
            this.status = API_RESPONSE_STATUS_FAILURE_CONFLICT;
            break;
          default:
            this.status = API_RESPONSE_STATUS_FAILURE_DEFAULT;
        }
      } else {
        // エラーがない場合（＝成功）
        this.status = API_RESPONSE_STATUS_SUCCESS;
        if (this.apiSuccessMessage) {
          // プロパティでメッセージが指定されている場合は設定する
          this.responseMessage = this.apiSuccessMessage;
        }
      }
      if (this.responseMessage === '') {
        this.responseMessage = ApiResponseMessages.find(e => e.status === this.status)!.message;
      }
    }
  }

  /**
   * ステータスアクションボタンを押下した際アクションIDを通知
   * loadingOverlayを表示
   * @param {string} - アクションID
   */
  @Emit('buttonClick')
  private buttonClick(value: string): string {
    this.isLoading = true;
    return value;
  }

  /**
   * 親コンポーネントに押下したか否か通知する
   * @module addDetailsOpratipon
   * @return boolean - false
   */
  @Emit('confirmOpratipon')
  public confirmOpratipon(): boolean {
    return false;
  }

  /**
   * API後の「確認ボタン」を押下した旨を通知
   * 内部プロパティの
   * ・アイテム情報
   * ・ステータスアクション情報
   * ・状態情報
   * を初期化
   * @return boolean
   */
  @Emit('successOpratipon')   
  private successOpratipon(){
    this.status = '';
    return true;
  }
}
